import _ from 'lodash'
import classNames from 'classnames'
import React from 'react'
import Card from 'components/shared/Card'
import IconSVG from 'svg-inline-react'
import { IconStyles, IconPickerConfig } from './Constants'
import style from './style.styl'

const IconSet = ({
  iconStyle,
  selectedIconStyle,
  foregroundColor,
  backgroundColor,
  onSelection,
  iconPickerConfig
}) => {
  const { chatSrc, feedbackSrc, announcementSrc, npsSrc } = iconPickerConfig[iconStyle]
  const selected = iconStyle === selectedIconStyle
  const customStyle = selected ? { color: `#${foregroundColor}`,
                                   backgroundColor: `#${backgroundColor}`}
                    : undefined
  const handleSelection = selected ? _.noop : onSelection
  return (
    <div onClick={_.partial(handleSelection, iconStyle)}>
      <Card style={customStyle} className={classNames(style.IconSet, {selected})}>
        <div className="flex-space-around">
          <IconSVG src={chatSrc} />
          <IconSVG src={feedbackSrc} />
        </div>
        <div className="flex-space-around">
          <IconSVG src={announcementSrc} />
          <IconSVG src={npsSrc} />
        </div>
      </Card>
    </div>
  )
}

const IconPicker = ({
  selectedIconStyle,
  foregroundColor,
  backgroundColor,
  onSelection,
  iconPickerConfig}) => (

  <div className={style.IconPicker}>
    <div className={style.IconPickerRow}>
      <IconSet iconStyle={IconStyles.SOLID1}
               selectedIconStyle={selectedIconStyle}
               foregroundColor={foregroundColor}
               backgroundColor={backgroundColor}
               onSelection={onSelection}
               iconPickerConfig={iconPickerConfig}
      />
      <IconSet
          iconStyle={IconStyles.SOLID2}
          selectedIconStyle={selectedIconStyle}
          foregroundColor={foregroundColor}
          backgroundColor={backgroundColor}
          onSelection={onSelection}
          iconPickerConfig={iconPickerConfig}
      />
    </div>
    <div className={style.IconPickerRow}>
      <IconSet
          iconStyle={IconStyles.OUTLINE1}
          selectedIconStyle={selectedIconStyle}
          foregroundColor={foregroundColor}
          backgroundColor={backgroundColor}
          onSelection={onSelection}
          iconPickerConfig={iconPickerConfig}
      />
      <IconSet
          iconStyle={IconStyles.OUTLINE2}
          selectedIconStyle={selectedIconStyle}
          foregroundColor={foregroundColor}
          backgroundColor={backgroundColor}
          onSelection={onSelection}
          iconPickerConfig={iconPickerConfig}
      />
    </div>
  </div>
)

IconPicker.defaultProps = {
  iconPickerConfig: IconPickerConfig
}

export default IconPicker



// WEBPACK FOOTER //
// ./src/scripts/components/Customize/Styling/IconPicker/index.js